import { render } from "./AuthLayout.vue?vue&type=template&id=730ed79b&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=730ed79b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__